import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login berhasil");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-glow-cyan relative" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8 flex justify-center">
          <BrandLogo size="lg" subtitle="Admin Panel" />
        </div>

        <form onSubmit={submit} className="border border-white/10 bg-[#0F0F11] p-8">
          <h2 className="font-heading text-2xl font-black text-white mb-6">MASUK ADMIN</h2>

          <div className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-gray-400 font-semibold block mb-2">Email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="admin-email-input"
                  className="w-full bg-[#0A0A0B] border border-white/20 text-white pl-10 pr-4 py-3 focus:border-[#00E5FF] outline-none"
                  placeholder="admin@rentalps.com"
                />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-gray-400 font-semibold block mb-2">Password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="admin-password-input"
                  className="w-full bg-[#0A0A0B] border border-white/20 text-white pl-10 pr-4 py-3 focus:border-[#00E5FF] outline-none"
                  placeholder="••••••••"
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full mt-6 bg-[#00E5FF] text-black font-bold py-3 uppercase tracking-wider text-sm hover:bg-white transition-colors disabled:opacity-50"
          >
            {loading ? "Masuk..." : "Login"}
          </button>

          <div className="mt-6 pt-6 border-t border-white/5 text-xs text-gray-500 text-center">
            Hanya admin resmi yang bisa mengakses panel ini.
          </div>
        </form>
      </div>
    </div>
  );
}
